import { z } from 'zod';

export const createInstitutionSchema = z.object({
  display_name: z.string().min(1, 'Display name is required'),
  address: z.string().min(1, 'Address is required'),
  city: z.string().min(1, 'City is required'),
  state: z.string().min(1, 'State is required'),
  zip_code: z.string().min(1, 'Zip code is required'),
  country: z.string().min(1, 'Country is required'),
  company_registration: z.string().min(1, 'Company registration is required'),
  avatar_url: z.string().optional(),
  avatar: z.string().optional(),
});

export type CreateInstitutionPayload = z.infer<typeof createInstitutionSchema>;
